// Mentions légales — page statique publique

import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { LogoPreventionScop } from '../components/layout'
import { Separator } from '../components/ui/separator'

export default function MentionsLegalesPage() {
  useEffect(() => { window.scrollTo(0, 0) }, [])
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-white">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/">
            <LogoPreventionScop className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="size-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      {/* Contenu */}
      <main className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">Mentions légales</h1>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Informations légales</h2>
          <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
            <p>
              Le site <strong className="text-foreground">Diag SCOP Prévention</strong> (diagscopprevention.fr)
              est édité par l'Organisme Professionnel de Prévention du Bâtiment et des Travaux Publics
              (ci-après « l'OPPBTP ») dont le siège est sis 25 avenue du Général Leclerc,
              92660 Boulogne-Billancourt Cedex.
            </p>
            <p>Immatriculé au répertoire SIREN sous le numéro 775 725 914.</p>
            <p>Téléphone : 01 46 09 27 00</p>
            <p>Adresse électronique : cn@oppbtp.fr</p>
            <p>
              Directeur de la publication : Paul Duphil, en sa qualité de secrétaire général de l'OPPBTP.
            </p>
            <p>
              Responsable de la rédaction : Barbara Muntaner, en sa qualité de rédacteur en chef.
            </p>
            <p>
              Responsable du traitement (des données personnelles) : la Direction du numérique
              représentée par Cyrille Goussard, en sa qualité de directeur du numérique.
            </p>
            <p>
              Le site est hébergé par <strong className="text-foreground">Codein</strong>, Montpellier, France.{' '}
              <span className="italic">6 RUE DE MAGUELONE 34000 MONTPELLIER, SIREN : 808 278 089</span>
            </p>
          </div>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Contenu du site et responsabilité de l'éditeur</h2>
          <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
            <p>
              L'OPPBTP s'efforce de fournir aux internautes des informations appropriées à leurs besoins
              au moment de leur mise en ligne.
            </p>
            <p>
              Toutefois, ces informations sont fournies à titre indicatif et seront utilisées par
              l'internaute sous sa responsabilité exclusive.
            </p>
            <p>
              De plus, il est entendu que l'OPPBTP n'est en aucune façon responsable des informations
              stockées par les internautes sur le site Diag SCOP Prévention.
            </p>
            <p>
              Par conséquent, l'OPPBTP ne saurait en aucun cas être tenu responsable des éventuels
              préjudices liés à la consultation de ces informations et de l'utilisation qui sera faite
              par les internautes des informations contenues dans le site.
            </p>
            <p>
              Il appartient aux utilisateurs de prendre toutes les mesures appropriées pour la protection
              de leur matériel, données ou logiciels informatiques notamment contre les virus informatiques
              circulant sur le réseau. L'OPPBTP ne saurait en aucun cas être tenu responsable des dommages
              causés par un virus lors de la connexion à son site.
            </p>
            <p>
              L'OPPBTP décline toute responsabilité pour les difficultés rencontrées lors de l'accès à son
              site ou pour toute défaillance de communication.
            </p>
            <p>
              L'OPPBTP se réserve le droit de modifier, corriger ou supprimer le contenu du site.
            </p>
          </div>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Propriété intellectuelle</h2>
          <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
            <p>
              Le site constitue en lui-même une œuvre protégeable au titre du droit d'auteur dont l'OPPBTP
              est propriétaire exclusif. En conséquence, il appartient seul à l'OPPBTP d'autoriser une
              éventuelle reproduction, représentation ou modification de son site et des éléments
              protégeables au titre du droit d'auteur qui le composent, à savoir : textes, vidéos, images,
              schémas, charte graphique, photographies, slogans, dessins, etc.
            </p>
            <p>
              Par conséquent, toute exploitation de ces éléments sans autorisation écrite, expresse et
              préalable de l'OPPBTP est strictement interdite et constituerait le cas échéant un acte de
              contrefaçon conformément au Livre I du Code de la propriété intellectuelle.
            </p>
            <p>
              Toutes les marques, logos, dénominations sociales et autres signes distinctifs présents sur
              le site sont protégés au titre du droit des marques dont l'OPPBTP est propriétaire exclusif
              ou dûment autorisé à les exploiter.
            </p>
            <p>
              Les reproductions, sur un support papier ou informatique, du site et des œuvres qui y sont
              reproduites sont autorisées sous réserve qu'elles soient strictement réservées à un usage
              personnel et privé, excluant tout usage à des fins publicitaires et/ou commerciales,
              conformément aux dispositions de l'article L.122-5 du Code de la propriété intellectuelle.
            </p>
          </div>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Données personnelles</h2>
          <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
            <p>
              À l'occasion de l'utilisation du site Diag SCOP Prévention, l'utilisateur peut être amené à
              communiquer des informations nominatives personnelles à l'OPPBTP. Les données ainsi
              collectées sont tenues strictement confidentielles et sont destinées à l'usage exclusif de
              l'OPPBTP et de ses collaborateurs assurant la gestion des services offerts par le site.
            </p>
            <p>
              Conformément au Règlement Général sur la Protection des Données personnelles (RGPD),
              les personnes ayant communiqué des données personnelles disposent d'un droit d'accès,
              de modification, d'opposition ou de suppression des informations les concernant en écrivant
              à l'adresse email{' '}
              <a href="mailto:rgpd@oppbtp.fr" className="text-primary hover:underline">rgpd@oppbtp.fr</a>.
            </p>
            <p>
              Pour plus de précisions sur le traitement de vos données personnelles, consultez notre{' '}
              <Link to="/confidentialite" className="text-primary hover:underline">
                politique de confidentialité
              </Link>.
            </p>
          </div>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Loi applicable</h2>
          <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
            <p>
              Le présent site est soumis au droit français.
            </p>
            <p>
              Toute interprétation, contestation ou revendication pourra être adressée à l'OPPBTP
              à l'adresse suivante : 25 avenue du Général Leclerc, 92660 Boulogne-Billancourt Cedex
              et sera en dernier lieu soumise à la compétence des tribunaux français.
            </p>
          </div>
        </section>
      </main>
    </div>
  )
}
